const commonPattern = 'nav-level-1-';

window.addEventListener('load', () => {
  document.querySelectorAll('.mobile-main-menu ul li a span').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.mobile-main-menu ul li a span').forEach(ele => {
        ele.classList.remove('header__active-menu-item');
      });
      item.classList.add('header__active-menu-item');
    });
  });

  document.querySelectorAll('.tws-cont[task-type="switch"] a').forEach((item) => {
    let itemHref = item.getAttribute('href');
    if (itemHref.startsWith('#')) {
      let menuToClick = itemHref.split('#')[1];
      item.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector(`.open-drawer-top-menu-item span[data-handle="${menuToClick}"]`).click();
      });
    }
  });

  document.addEventListener("OpenDrawer", () => {
    drawerOpened();
  });

  document.addEventListener("CloseDrawer", () => {
    drawerClosed();
  });
});

function preventDefaultHandler(event) {
  event.preventDefault();
}

const drawerOpened = () => {
  console.log('drawer opened');
  document.querySelector('sticky-header').classList.add('mobile-main-menu_open');
  document.querySelectorAll('.mobile-main-menu ul li a').forEach((item) => {
    item.classList.add('open-drawer-top-menu-item');
    item.addEventListener('click', preventDefaultHandler);
  });
  document.querySelector('html').style.overflow = 'hidden';

  let navSelected;
  // if (document.querySelector('a.header__menu-item > .header__active-menu-item'))
  //   navSelected = `${commonPattern}${document.querySelector('a.header__menu-item > .header__active-menu-item').getAttribute('data-handle')}`;
  // else
  //   navSelected = document.querySelector('.tws-cont').getAttribute('data-handle');

  // You can dispatch a custom event here to open the correct menu in your new system if needed
  // openMenul1(`${navSelected}`)
};

const drawerClosed = () => {
  console.log('drawer closed');
  document.querySelector('sticky-header').classList.remove('mobile-main-menu_open');
  document.querySelectorAll('.mobile-main-menu ul li a').forEach((item) => {
    item.classList.remove('open-drawer-top-menu-item');
    item.removeEventListener('click', preventDefaultHandler);
  });
  document.querySelectorAll('.mobile-main-menu ul li a span').forEach(ele => {
    ele.classList.remove('header__active-menu-item');
  });

  document.querySelector('html').style.overflow = 'auto';

  if (document.querySelector(`.header__default-menu-item[data-handle="${localStorage.getItem('lastVisitedLandingPage')}"]`)) {
    document.querySelector(`.header__default-menu-item[data-handle="${localStorage.getItem('lastVisitedLandingPage')}"]`).classList.add('header__active-menu-item');
  }

  // ✅ Reset all submenus and panels
  document.querySelector('.tws-l1-panel')?.classList.add('is-active');

  document.querySelectorAll('.tws-panel.tws-l2-panel, .tws-panel.tws-l3-panel').forEach(panel => {
    panel.classList.remove('is-active');
    panel.classList.remove('closing'); // if in mid-animation
  });

  document.querySelectorAll('.tws-l2-group, .tws-l3-group').forEach(group => {
    group.classList.remove('active');
  });

  // Optional: scroll to top
  document.querySelectorAll('.tws-panel').forEach(panel => {
    panel.scrollTop = 0;
  });
};

const footerCopy = () => {
  const sourceDiv = document.querySelector('footer.footer');
  const targetDiv = document.querySelector('.menu-drawer_footer');

  if (sourceDiv && targetDiv) {
    const clonedDiv = sourceDiv.cloneNode(true);
    const unwantedElement = clonedDiv.querySelector(".footer__content-top .klaviyo-form-YeUMp9");
    if (unwantedElement) {
      unwantedElement.remove();
    }
    targetDiv.appendChild(clonedDiv);
    targetDiv.style.display = 'block';
    console.log('Div copied and pasted successfully.');
  } else {
    console.error('Source or target div not found.');
  }
};

function updateLastVisitedPage() {
  const path = window.location.pathname;
  let menuItems = document.querySelectorAll('.header__menu-item > span');
  if (path.startsWith('/pages/') || path == '/') {
    let landingPage = path.split('/pages/')[1];
    localStorage.setItem('lastVisitedLandingPage', landingPage);
  } else {
    let option = localStorage.getItem('lastVisitedLandingPage');
    menuItems.forEach(item => {
      item.classList.remove('header__active-menu-item');
    });
    document.querySelectorAll(`.header__menu-item > span[data-handle="${option}"]`).forEach((item) => {
      item.classList.add('header__active-menu-item');
    });
  }
}